import { render } from "./CO2.vue?vue&type=template&id=72afe624"
import script from "./CO2.vue?vue&type=script&lang=ts"
export * from "./CO2.vue?vue&type=script&lang=ts"
script.render = render

export default script